import { Navigate, Outlet } from "react-router-dom";
import BusyIndicatorHTML from "../components/BusyIndicator/BusyIndicatorHTML";
import { RoutePath } from "../constants/RoutePath";
import { useTenant } from "./useTenant";

export default function RequireTenant() {
  const { Status, ResolveTenant } = useTenant();

  if (Status === "Initializing") {
    return (
      <BusyIndicatorHTML
        isOpen
        mode="overlay"
        message="Finding your business..."
      />
    );
  }

  if (Status === "Error") {
    return (
      <main className="tenant-resolution-error">
        <h1>We could not load this business</h1>
        <button type="button" onClick={() => void ResolveTenant()}>
          Try again
        </button>
      </main>
    );
  }

  return Status === "Found" ? (
    <Outlet />
  ) : (
    <Navigate to={RoutePath.TenantSetup} replace />
  );
}
